import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import rootReducer from './rootReducer';
import { api as accountAPI } from '../Account/api';
import { api as authAPI } from '../Auth/api';
import { api as OAuthAPI } from '../Auth/api/oauth';

export const store = configureStore({
	reducer: rootReducer,
	//  [api.reducerPath]: api.reducer

	middleware: getDefaultMiddleware =>
		getDefaultMiddleware()
			.concat(accountAPI.middleware)
			.concat(OAuthAPI.middleware)
			.concat(authAPI.middleware),
	devTools: process.env.NODE_ENV !== 'production'
});

export type AppDispatch = typeof store.dispatch;

export type RootStates = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
